
<div class="loading-container">
    <ngx-loading-bar color="green" diameter="25px" height="3px" [includeSpinner]=true></ngx-loading-bar>
</div>

<div>
    <app-toolbar *ngIf="!hideHeader"></app-toolbar>
    <router-outlet></router-outlet>
</div>
